import { cn } from '../../utils';

type SvgMaskIconProps = {
  src: string;
  width?: number;
  height?: number;
  className?: string;
};

export function SvgMaskIcon({
  src,
  width = 24,
  height = 24,
  className,
}: SvgMaskIconProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block bg-menuIconColor', className)}
      style={{
        width,
        height,
        mask: `url("${src}") center / contain no-repeat`,
        WebkitMask: `url("${src}") center / contain no-repeat`,
      }}
    />
  );
}
